import axios from '@/core/axios';

import {
  ManagementControlTab,
  RefundReconciliationFilters,
  RefundReconciliationResponse
} from './management-controls.types';

export class ManagementControlsService {
  async refundReconciliation(filters: RefundReconciliationFilters = {}): Promise<RefundReconciliationResponse> {
    const resp = await axios.get<RefundReconciliationResponse>('/management-controls/refund-reconciliation', {
      params: filters
    });
    return resp?.data;
  }

  async updateComment(tab: ManagementControlTab, rowKey: number | string, comment: string): Promise<string> {
    const resp = await axios.put<{ comment: string }>('/management-controls/comment', {
      tab,
      row_key: rowKey,
      comment
    });
    return resp?.data?.comment;
  }
}

export const managementControlsService = new ManagementControlsService();
